var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPistaDeCorridaMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 995,
    height: 293,
    viewBox: "0 0 995 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1003 0H-964V293H1003V0Z",
    fill: "#F27863"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1003 44H-964V47H1003V44Z",
    fill: "#B8B8B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1003 110H-964V113H1003V110Z",
    fill: "#B8B8B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1003 180H-964V183H1003V180Z",
    fill: "#B8B8B8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    width: 44,
    height: 293,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 32.816,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 65.632,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 98.448,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 131.264,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 164.08,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 196.896,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 229.712,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 262.528,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 16.408,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 49.224,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 82.04,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 114.856,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 147.672,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 180.488,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 213.304,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 246.12,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 278.936,
    width: 15,
    height: 14.064,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 32.816,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 65.632,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 98.448,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 131.264,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 164.08,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 196.896,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 229.712,
    width: 15,
    height: 16.408,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 262.528,
    width: 15,
    height: 16.408,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPistaDeCorridaMobile);
export default __webpack_public_path__ + "static/media/pista-de-corrida-mobile.0de21e4de7a83b33e9bb7f55b253e543.svg";
export { ForwardRef as ReactComponent };